// extracted by mini-css-extract-plugin
module.exports = {"qr_code_container":"watchVideo_qr_code_container__OSF3w","video_wrapper":"watchVideo_video_wrapper__orOIA"};